import { ControlType, FormFieldBase } from './form-field-base.model';

export class TextViewFormField extends FormFieldBase<string | number> {
  controlType: ControlType = 'textview';
}
